import React from "react";
import Hero from "../../components/HomeComponents/Hero";
import AboutHomeSection from "../../components/HomeComponents/aboutSection";


const HomePage = () => {
  return (
    <div className="bg-white py-10 sm:p-10">
      <Hero />
      <AboutHomeSection />
    </div>
  );
};

export default HomePage;
